import { countriesService } from '../services/countries.service'

export const countries = {
  namespaced: true,
  state: {
    countries: [],
    currencies: []
  },
  actions: {
    async getCountries ({ state, commit }) {
      if (state.countries.length > 0) return
      return new Promise((resolve, reject) => {
        countriesService.getCountries()
          .then(
            res => {
              resolve(res)
              commit('setCountries', res.data)
            },
            err => {
              reject(err)
            }
          )
      })
    },
    async getCurrencies ({ state, commit }) {
      if (state.currencies.length > 0) return
      return new Promise((resolve, reject) => {
        countriesService.getCurrencies()
          .then(
            res => {
              resolve(res)
              commit('setCurrencies', res.data)
            },
            err => {
              reject(err)
            }
          )
      })
    }
  },
  mutations: {
    setCountries (vuexState, payload) {
      vuexState.countries = payload
    },
    setCurrencies (vuexState, payload) {
      vuexState.currencies = payload
    }
  },
  getters: {

  }
}
